export enum EnumSpliter {
	COMMA = ',',
	SPACE = ' ',
}
